/**
 * Ficheiro de imagem a usar na thumb das listas de imóveis/empreendimentos.
 *
 * A listagem devolve TODOS os ficheiros do imóvel (imagens e documentos)
 * ordenados por `order`, porque o mesmo payload alimenta as imagens e os
 * documentos. Usar `propertyFiles[0]` às cegas punha um PDF na `<img>`, que
 * falhava e deixava o imóvel sem imagem. Aqui escolhe-se a primeira imagem;
 * quando o payload não traz `fieldName` (endpoints que já filtram imagens no
 * servidor) mantém-se o primeiro ficheiro.
 */
export function firstPropertyImageFileName(
  files: any[] | null | undefined,
): string {
  const list = Array.isArray(files) ? files : [];
  const hasFieldName = list.some((f: any) => f?.fieldName !== undefined);
  const candidate = hasFieldName
    ? list.find((f: any) => f?.fieldName === "images" && f?.fileName)
    : list.find((f: any) => f?.fileName);
  return candidate?.fileName ?? "";
}
